import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import { PageSkeleton } from 'modules/pages/components/PageSkeleton'
import CollectionsBootstrap from 'modules/pages/lib/CollectionsBootstrap'
import { PagesContextProvider } from 'modules/pages/lib/context/PagesProvider'
import { usePagesContext } from 'modules/pages/lib/hooks/usePagesContext'

const PagesRootPage = () => {
  const { canSeePages, loading } = usePagesContext()

  if (loading) {
    return <PageSkeleton />
  }

  const authorizeFn = () => {
    return canSeePages
  }

  return (
    <AuthorizeUser authorizeFn={authorizeFn}>
      <Outlet />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <PagesContextProvider>
        <PagesRootPage />
      </PagesContextProvider>
    </CollectionsBootstrap>
  )
}

export default RootPage
